import { useGlobalFeatureFlags } from '../../shell/providers/GlobalFeatureFlagsProvider'
import { isWebOnlineWritesActive } from '../../shell/feature-flags/webOnlineWrites'
import { useConnectivityStatus } from '../../shell/connectivity/useConnectivityStatus';
import { resolvePosOfflineHint } from './posOfflineHint';

export function useWebPosWriteGate() {
  const { flags } = useGlobalFeatureFlags();
  const { isOnline } = useConnectivityStatus();
  const webBlocksOfflineWrites = isWebOnlineWritesActive(flags);
  const chargeBlocked = webBlocksOfflineWrites && !isOnline;
  const offlineHint = resolvePosOfflineHint({ isOnline, webBlocksOfflineWrites });
  return { isOnline, webBlocksOfflineWrites, chargeBlocked, offlineHint };
}
